exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".competitors-results[data-v-bdbfb0b2]{position:relative}.competitors-results--loading>.competitors-table[data-v-bdbfb0b2],.competitors-results--loading>.pagination-container[data-v-bdbfb0b2]{opacity:.5;pointer-events:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Competitors/CompetitorsList.vue"],"names":[],"mappings":"AACA,sCACE,iBAAmB,CACpB,AACD,uIAEE,WAAa,AACb,mBAAqB,CACtB","file":"CompetitorsList.vue","sourcesContent":["\n.competitors-results[data-v-bdbfb0b2] {\n  position: relative;\n}\n.competitors-results--loading > .competitors-table[data-v-bdbfb0b2],\n.competitors-results--loading > .pagination-container[data-v-bdbfb0b2] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdbfb0b2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Competitors/CompetitorsList.vue
// module id = 1457
// module chunks = 26